import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { AlertsService } from "@jaspero/ng2-alerts";
import { Subscription } from "rxjs/Subscription";

import { GUID, Param } from "app/brightserve/brightserve.module";

import { ClientsService } from "app/clients/clients.service";
import { Client } from "app/shared/shared.module";
import { ModalDirective } from 'ngx-bootstrap';
import { SharedCommonService } from "app/shared/shared-common.service";

@Component({
    selector: 'app-client-detail-information',
    templateUrl: './client-detail-information.component.html',
    styleUrls: ['./client-detail-information.component.css']
})
export class ClientDetailInformationComponent implements OnInit {

    Id: GUID;
    Client: Client;
    EditClient: Client = new Client({ ContractStatus: new Param() });
    GetClientSubscription: Subscription;
    sub: Subscription;
    EditClientSubscription: Subscription;
    AddSyncClientSubscription: Subscription;

    ContactStatuses: Param[] = [
        new Param({ Entity: "Client", Field: "ContractStatus", Value: "Active" }),
        new Param({ Entity: "Client", Field: "ContractStatus", Value: "Expired" })
    ];

    VesselPurposes: Param[] = [
        new Param({ Entity: "Client", Field: "VesselPurpose", Value: "Commercial" }),
        new Param({ Entity: "Client", Field: "VesselPurpose", Value: "Leisure" }),
    ];

    VesselLengths: Param[] = [
        new Param({ Entity: "Client", Field: "VesselLength", Value: "Over100m", Definition: "Over 100m" }),
        new Param({ Entity: "Client", Field: "VesselLength", Value: "50m100m", Definition: "50m to 100m" }),
        new Param({ Entity: "Client", Field: "VesselLength", Value: "Under50m", Definition: "Under 50m" })
    ];
    CanEditThemisSystemNumber: boolean = false;
    ClientInformationEdit: boolean = false;
    VesselInformationEdit: boolean = false;
    VesselContactInformationEdit: boolean = false;
    ClientContactInformationEdit: boolean = false;

    @ViewChild('EditOrganisationModal') public modal: ModalDirective

    @ViewChild('AddSyncClientModal') public syncClientmodal: ModalDirective

    constructor(private clientService: ClientsService, private activatedRoute: ActivatedRoute, private sharedCommonService: SharedCommonService) {
    };

    ngOnInit() {
        this.sub = this.activatedRoute.parent.params.subscribe(params => {
            if (params && params['id']) {
                this.Id = params['id'];
                this.GetClient();
            }
        });
    };

    ngOnDestroy() {
        this.sub.unsubscribe();
        if (this.GetClientSubscription != null)
            this.GetClientSubscription.unsubscribe();
    };

    openEdit(editForm: string) {
        this.EditClient = new Client(this.Client);
        this.EditClient.ContractStatus = this.ContactStatuses.filter(x => x.Value == this.Client.ContractStatus.Value)[0];
        this.EditClient.VesselPurpose = this.VesselPurposes.filter(x => x.Value == this.Client.VesselPurpose.Value)[0];
        this.EditClient.VesselLength = this.VesselLengths.filter(x => x.Value == this.Client.VesselLength.Value)[0];

        this.closeAll();

        switch (editForm) {
            case "ClientInformation":
                this.ClientInformationEdit = true;
                break;
            case 'VesselInformation':
                this.VesselInformationEdit = true;
                break;
            case 'VesselContactInformation':
                this.VesselContactInformationEdit = true;
                break;
            case 'ClientContactInformation':
                this.ClientContactInformationEdit = true;
                break;
        }
    };

    closeAll() {
        this.ClientInformationEdit = false;
        this.VesselInformationEdit = false;
        this.VesselContactInformationEdit = false;
        this.ClientContactInformationEdit = false;
    };

    GetClient() {
        this.GetClientSubscription = this.clientService.GetClient(this.Id).subscribe(
            client => {
                this.Client = client;
                // if the code is null, not a number then anyone can change it
                // otherwise only system can change it.
                var parsedCode = parseInt(this.Client.Code);
                if (parsedCode == 0 || isNaN(parsedCode))
                    this.CanEditThemisSystemNumber = true;
                else
                    this.sharedCommonService.GetUserDetails().subscribe((res) => {
                        this.CanEditThemisSystemNumber= res.User.Username == "system";
                });
            }, err => {
                console.log(err);
            });
    };
    SaveClient() {
        this.EditClientSubscription = this.clientService.UpdateClient(this.Id, this.EditClient).subscribe(
            client => {
                this.closeAll();
                this.GetClient();
                if (this.modal)
                    this.modal.hide();
            }, err => {
                console.log(err);
            });
    };

    OpenAddSyncClientModal() {
        this.EditClient = new Client(this.Client);
        this.syncClientmodal.show();
    };

    NewSyncId() {
        return GUID.newGuid();
    };
    AddSyncClient() {
        this.AddSyncClientSubscription= this.clientService.AddSyncClient(this.Id, this.EditClient).subscribe(
            client => {
                this.GetClient();
                this.syncClientmodal.hide();
            }, err => {
                console.log(err);
            });
    };
}



// WEBPACK FOOTER //
// ./src/app/clients/details/information/client-detail-information.component.ts